import { Pipe, PipeTransform } from '@angular/core';
import { sortBy } from 'lodash';

@Pipe({ name: 'orderBy' })
export class OrderByPipe implements PipeTransform {
  public transform<T>(array: T[], key?: keyof T, direction?: 'ASC' | 'DESC'): T[] {
    const result = array || [];

    if (!key || !direction) {
      return result;
    }
    if (direction !== 'ASC' && direction !== 'DESC') {
      return result;
    }
    return sortBy(result, (item) => item[key], direction.toLowerCase());
  }
}
